import SpuPromotionInfo from '../SpuPromotionInfo';
import { DiscountBarView } from './DiscountBar';
import VoteArea from './VoteArea';
import { CustomRichTextItemView } from './customRich';
import { DynamicTagItemView } from './dynamic';

/*
~~~~~~~~~~~~~   使用方法：  ~~~~~~~~~~~~~~~~~~~~

支持解析：
//    SHOP_NAME("shopName", "门店名称"),
//    SHOP_SCORE("shopScore", "商户评分"),
//    SHOP_CATEGORY("shopCategory", "门店分类"),
//    SHOP_AVG_SPEND("shopAvgSpend", "门店人均销量金额（新）"),
//    DELIVERY_TIME("deliveryTime", "配送时间"),
//    DISTANCE("distance", "距离"),
//    DELIVERY_FEE("deliveryFee", "配送费"),
//    DYNAMIC_TAGS("dynamicTags", "动态标签"),
//    SHOP_SALE_INFO("shopSaleInfo", "30天销量"),
//    MIN_COST_PRICE("minCostPrice", "起送价"),
//    NEAR_CLOSING_TIME("nearClosingTime", "临近闭店时间"),

{content.length > 0 && <view className="procuct-content-container">
{content.map((warp, line) => {
    return warp?.length > 0 ? (
        <view key={line} className="procuct-content-item-container">
            {warp?.map((item, index) => {
                // 当前渲染
                const attachmentData = attachments[item?.type]
                // 下一个渲染
                const lastAttachmentData = attachments[warp?.[index + 1]?.type]
                // 可空： 默认是点 可选空格，spec 间距可调 默认 3
                const specStyle = item?.type === 'shopScore' ? {specType: ContentSpecType.BlankSpace, spec: 8 } : {specType: ContentSpecType.Point, spec: 4 }
                // 可空：某个item的特殊样式处理传参： 外层maxhLiens等参数为外层容器特有参数，平级customProperty可以传特殊样式及特殊传参
                const attachmentStyle = item.type === 'shopScore' ? {customProperty: { hasBorder: true }} : {}

                if (attachmentData) {
                    return <attachmentData.attachment
                                key={`item.type_${line}_${index}`}
                                itemKey={item?.type}        // 必传
                                data={item?.data}           // 必传
                                hasLastItem={lastAttachmentData !== undefined} // 必传
                                specStyle={specStyle}       // 可空
                                style={attachmentStyle}     // 可空
                                />
                }
                return null
            })}
        </view>
    ) : null;
})}
</view>}

tip: 新加入 type 需要在 attachments中加入 解析对应的view, view集成于 itemSuperCard

*/
const attachments = {
  dynamicTags: { attachment: DynamicTagItemView },
  nearClosingTime: { attachment: DynamicTagItemView },
  spuDynamicTags: { attachment: DynamicTagItemView },
  spuRecommendReason: { attachment: DynamicTagItemView },
  rcmdLabelLong: { attachment: DynamicTagItemView, staticConfig: { itemKey: 'recommendTags' } },
  rcmdLabelShort: { attachment: DynamicTagItemView, staticConfig: { itemKey: 'recommendTags' } },

  spuFinalPrice: { attachment: CustomRichTextItemView },
  shopName: { attachment: CustomRichTextItemView },
  subCardTitle: { attachment: CustomRichTextItemView },
  shopScore: { attachment: CustomRichTextItemView },
  distance: { attachment: CustomRichTextItemView },
  minCostPrice: { attachment: CustomRichTextItemView },
  shopAvgSpend: { attachment: CustomRichTextItemView },
  shopCategory: { attachment: CustomRichTextItemView },
  shopSaleInfo: { attachment: CustomRichTextItemView },
  deliveryTime: { attachment: CustomRichTextItemView },
  deliveryFee: { attachment: CustomRichTextItemView },
  brandName: { attachment: CustomRichTextItemView },
  shopLabel: { attachment: CustomRichTextItemView },
  spuName: { attachment: CustomRichTextItemView },
  spuPrice: { attachment: CustomRichTextItemView },
  foodPrepareTime: { attachment: CustomRichTextItemView },
  shippingFreeIcon: { attachment: CustomRichTextItemView },
  spuDesc: { attachment: CustomRichTextItemView },
  // 自定义类型
  spuPromotionInfo: { attachment: SpuPromotionInfo },
  outOfRangeInfo: { attachment: CustomRichTextItemView },
  discountBar: { attachment: DiscountBarView },
  alienSpuFinalPrice: { attachment: CustomRichTextItemView }, // 单行异形价格（突出整数部分）
  spuDrawlinePrice: { attachment: CustomRichTextItemView },
  shopLogo: { attachment: CustomRichTextItemView },
  spuDBLRowName: { attachment: CustomRichTextItemView },
  productDeliveryFee: { attachment: CustomRichTextItemView }, //一人食后端链路的商品运费
  pickupPricePromotionTag: { attachment: DynamicTagItemView },
  // 必吃榜定制投票组件
  voteArea: { attachment: VoteArea },
};

function getAttachments(item: any) {
  const type = item?.type;
  const attachment = attachments[type];
  if (attachment === undefined && type !== undefined && item?.data?.dynamicTags) {
    // 带有通用dynamicTags 数据的 兜底动态标签组件，目前在部分卡片中使用
    return { attachment: DynamicTagItemView };
  }
  return attachment;
}

export { attachments, getAttachments };
